import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DataGridComponent } from "../../components/common/DataGridComponent";
import useSiteLabVendorsColumns from "../../components/SiteLabVendors/useSiteLabVendorsColumns";
import { useSiteLabVendorsDetails } from "../../components/SiteLabVendors/useSiteLabVendorsDetails";

const SitesLab: React.FunctionComponent<any> = () => {
  const columns = useSiteLabVendorsColumns();
  const { rowData } = useSiteLabVendorsDetails();
  const navigate = useNavigate();
  const actions = {
    id: (data: any) => {
      navigate(`/sites-lab/${data?.id}`);
    },
    studyID: (data: any) => {
      //   console.debug(data);
    },
    actionsColumn: {
      action_edit: (data: any) => {
        // console.debug(data)
      },
      action_delete: (data: any) => (data: any) => {
        // console.debug(data)
      },
    },
  };
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs>
          <Typography variant="h4" gutterBottom>
            Sites, Labs & Vendors
          </Typography>
        </Grid>
        <Grid item justifyContent="flex-end">
          &nbsp;
        </Grid>
      </Grid>
      <Box sx={{ width: "100%", height: "calc(100vh - 150px)" }}>
        <DataGridComponent
          columns={columns as any}
          hasDefinedColumns={false}
          rows={rowData ?? []}
          showQuickFilter
          actions={actions}
        />
      </Box>
    </>
  );
};

export default SitesLab;
